import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
//import { createHttpLink } from 'apollo-link-http';
//import { HttpLink } from 'apollo-link-http';
//import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "react-apollo";
import './css/style.css';
import Single from './views/Single';
import EventList from './components/events/EventList';
import Event from './components/events/Event';
import Home from './views/Home';
import Notfound from './views/Notfound';

const client = new ApolloClient({
	uri: '/graphql'
});

ReactDOM.render(
	<ApolloProvider client={client}>
		<BrowserRouter>
			<Switch>
				<Route exact path="/" component={Home} />
				<Route path="/events/" component={EventList} />
				<Route path="/events/:slug" component={Event} />
				<Route path="/page/:slug" component={Single} />
				<Route path="/post/:slug" component={Single} />
				<Route component={Notfound} />     
			</Switch>
		</BrowserRouter>
	</ApolloProvider>, document.getElementById('root'));
